<template>
    <div>
        <!-- For Motor NB -->
        <div class="row app-overview-wrapper" v-if="checkMotorParent">
            <div class="col-12">
                <div class="row app-overview-row">
                    <div class="col-6 col-md-4 col-lg quote-summary mt-1 pt-2">
                        <div class="row">
                            <p><span class="label-value">Quote Summary</span></p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg pl-lg-0 quotation-number" v-if="completedb.generateQuote.policyDetails.motorQuoteApplicability">
                        <div class="row mr-0">
                            <p><span class="label-name">QUOTATION NO.</span><br>
                            <span class="label-value">{{completedb.quoteId ? completedb.quoteId : '-'}}</span></p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg-2 make-n-model">
                        <div class="row">
                            <p><span class="label-name">VEHICLE  MAKE & MODEL</span><br>
                            <span class="label-value">{{state.quoteObj.makeModelName}}</span></p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg make-n-model">
                        <div class="row">
                            <p class="label-make-model"><span class="label-name">RISK INCEPTION DATE</span><br>
                            <span class="label-value">{{dateObjFormated(proposalDetailsData.policyInceptionDetails.registrationDate.value)}}</span><br>
                            <span class="label-value">{{proposalDetailsData.policyInceptionDetails.riskInceptionTime.value}}</span></p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg product-name">
                        <div class="row">
                            <p><span class="label-name">PRODUCT NAME</span><br>
                            <span class=" label-value">{{state.quoteObj.productName}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg plan-name">
                        <div class="row mr-0">
                            <p><span class="label-name">PLAN NAME</span><br>
                            <span class=" label-value">{{state.quoteObj.planName}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg-1 pl-lg-2 plan-tenure">
                        <div class="row plan-tenure-row">
                            <p><span class="label-name">PLAN TENURE</span><br>
                            <span class=" label-value">{{state.quoteObj.planTenure}} <span v-if="state.quoteObj.planTenure=='1'"> Year</span><span v-else> Years</span></span>
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-2 pl-lg-0">
                        <div class="row total-premiun-row">
                            <p><span class="label-name">TOTAL PREMIUM</span><br>
                            <span class="label-value">&#8377; {{generateQuoteData.selectedPlan.totalPremium ? generateQuoteData.selectedPlan.totalPremium : '-'}}</span></p>
                        </div>
                    </div>
                    <div class="preview-btn-wrapper review-application" >
                        <button type="button" class="preview collapsed" data-toggle="collapse" data-target="#details_payment" id="review-application">Review Application</button>
                    </div>
                </div>
            </div>
            <!-- review application section starts -->
            <div class="col-12 app-overview-outer-div collapse px-lg-0 px-md-0" id="details_payment">
                <div class="app-overview-inner-div">
                    <div class="row pt-4 pb-3 ml-md-4 ml-2 mr-0">
                        <div class="col-12 col-md-3 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Registration Number</div>
                            <div class="row inner-label-value">{{generateQuoteData.riskDetails.registrationNumber.value}}</div>
                        </div>
                        <div class="col-6 col-md-3 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Title</div>
                            <div class="row inner-label-value">{{state.quoteObj.title ? state.quoteObj.title : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name">First Name</div>
                            <div class="row inner-label-value">{{proposalDetailsData.customerDetails.firstName.value ? proposalDetailsData.customerDetails.firstName.value : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name ">Middle Name</div>
                            <div class="row inner-label-value">{{proposalDetailsData.customerDetails.middleName.value ? proposalDetailsData.customerDetails.middleName.value : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2 pl-lg-4 padding-top-medium-screen">
                            <div class="row label-name ">Last Name</div>
                            <div class="row inner-label-value">{{proposalDetailsData.customerDetails.lastName.value ? proposalDetailsData.customerDetails.lastName.value : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2 padding-top-address-details padding-top-medium-screen">
                            <div class="row label-name">Address</div>
                            <div class="row inner-label-value">{{proposalDetailsData.correspondenceAddress.address.value}}, {{proposalDetailsData.correspondenceAddress.area.value}}, 
                                {{proposalDetailsData.correspondenceAddress.city.value}}, {{proposalDetailsData.correspondenceAddress.state.value}}, {{proposalDetailsData.correspondenceAddress.mailingPinCode.value}}
                            </div>
                        </div>
                    </div>
                    <div class="row pb-3 ml-md-4 ml-2 mr-0">
                        <div class="col-6 col-md-3 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Email Id</div>
                            <div class="row inner-label-value  break-word">{{proposalDetailsData.correspondenceAddress.emailId.value ? proposalDetailsData.correspondenceAddress.emailId.value : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Mobile Number</div>
                            <div class="row inner-label-value">{{proposalDetailsData.correspondenceAddress.mobileNumber.value ? proposalDetailsData.correspondenceAddress.mobileNumber.value : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name ">Engine Number</div>
                            <div class="row inner-label-value">{{proposalDetailsData.vehicleDetails.engineNumber.value ? proposalDetailsData.vehicleDetails.engineNumber.value : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name">Chassis Number</div>
                            <div class="row inner-label-value">{{generateQuoteData.riskDetails.chassisNumber.value ? generateQuoteData.riskDetails.chassisNumber.value : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 pb-3 pb-md-0 col-lg-2 pl-lg-4 padding-top-nominee-details">
                            <div class="row label-name">Nominee Name</div>
                            <div class="row inner-label-value">{{proposalDetailsData.personalAccidentCoverDetails.nomineeName.value ? proposalDetailsData.personalAccidentCoverDetails.nomineeName.value : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 pb-3 pb-md-0 col-lg-2 padding-top-nominee-details">
                            <div class="row label-name">Nominee Relationship</div>
                            <div class="row inner-label-value">{{proposalDetailsData.personalAccidentCoverDetails.nomineeRelation.value ? proposalDetailsData.personalAccidentCoverDetails.nomineeRelation.value : '-'}}</div>
                        </div>
                    </div>
                    <div class="row pt-4 pb-3 ml-md-4 ml-2 mr-0" v-if="proposalDetailsData.correspondenceAddress.panNumber.value != ''">
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name ">PAN Number</div>
                            <div class="row inner-label-value">{{proposalDetailsData.correspondenceAddress.panNumber.value ? proposalDetailsData.correspondenceAddress.panNumber.value : '-'}}</div>
                        </div>
                    </div>
                </div>
                <!-- review application section ends -->
            </div>
        </div>
        <!-- For standaloneCPA -->
        <div class="row app-overview-wrapper" v-if="!checkMotorParent">
            <div class="col-12">
                <div class="row app-overview-row">
                    <!-- <div class="col-6 col-md-4 col-lg-2 quote-summary mt-1 pt-2">
                        <div class="row">
                            <p><span class="label-value">Quote Summary</span></p>
                        </div>
                    </div> -->
                    <div class="col-6 col-md-4 col-lg-2 pl-lg-4 quotation-number">
                        <div class="row ">
                            <p><span class="label-name">QUOTATION NO.</span><br>
                            <span class="label-value">{{completedb.quoteId ? completedb.quoteId : '-'}}</span></p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg-2 ml-lg-2 make-n-model">
                        <div class="row">
                            <p><span class="label-name">SCPA NOMINEE NAME</span><br>
                            <span class="label-value">{{scpaDetails.driverDetails.driverDetailsOptions.nomineeName.value ? scpaDetails.driverDetails.driverDetailsOptions.nomineeName.value : '-'}}</span></p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg-2 pl-lg-0 ml-lg-0 product-name">
                        <div class="row">
                            <p><span class="label-name">SCPA NOMINEE RELATION</span><br>
                            <span class=" label-value">{{scpaDetails.driverDetails.driverDetailsOptions.nomineeRelation.value ? scpaDetails.driverDetails.driverDetailsOptions.nomineeRelation.value : '-'}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg-2 plan-name">
                        <div class="row">
                            <p><span class="label-name">SCPA DURATION </span><br>
                            <span class=" label-value">{{scpaDetails.driverDetails.driverDetailsOptions.duration.value}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="col-6 col-md-4 col-lg-1 pl-lg-0 plan-tenure">
                        <div class="row">
                            <p><span class="label-name">PARTY ID</span><br>
                            <span class=" label-value">{{completedb.generateQuote.partyId ? completedb.generateQuote.partyId : '-'}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-12 col-lg-2 pl-lg-0">
                        <div class="row">
                            <p><span class="label-name">TOTAL PREMIUM</span><br>
                            <span class="label-value">&#8377; {{generateQuoteData.selectedPlan.totalPremium ? generateQuoteData.selectedPlan.totalPremium : '-'}}</span></p>
                        </div>
                    </div>
                    <div class="preview-btn-wrapper review-application" >
                        <button type="button" class="preview collapsed" data-toggle="collapse" data-target="#details_payment" id="total-premium-review-application">Review Application</button>
                    </div>
                </div>
            </div>
            <!-- review application section starts -->
            <div class="col-12 app-overview-outer-div collapse px-lg-0 px-md-0" id="details_payment">
                <div class="app-overview-inner-div">
                    <div class="row pt-4 pb-3 ml-md-4 ml-2 mr-0">
                        <div class="col-6 col-md-3 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Title</div>
                            <div class="row inner-label-value">{{state.quoteObj.title ? state.quoteObj.title : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name">First Name</div>
                            <div class="row inner-label-value">{{proposalDetailsData.customerDetails.firstName.value ? proposalDetailsData.customerDetails.firstName.value : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name ">Middle Name</div>
                            <div class="row inner-label-value">{{proposalDetailsData.customerDetails.middleName.value ? proposalDetailsData.customerDetails.middleName.value : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name ">Last Name</div>
                            <div class="row inner-label-value">{{proposalDetailsData.customerDetails.lastName.value ? proposalDetailsData.customerDetails.lastName.value : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-4 padding-top-address-details padding-top-medium-screen">
                            <div class="row label-name">Address</div>
                            <div class="row inner-label-value">{{proposalDetailsData.correspondenceAddress.address.value}}, {{proposalDetailsData.correspondenceAddress.area.value}}, 
                                {{proposalDetailsData.correspondenceAddress.city.value}}, {{proposalDetailsData.correspondenceAddress.state.value}}, {{proposalDetailsData.correspondenceAddress.mailingPinCode.value}}
                            </div>
                        </div>
                    </div>
                    <div class="row pb-3 ml-md-4 ml-2 mr-0">
                        <div class="col-6 col-md-3 col-sm-6 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Email Id</div>
                            <div class="row inner-label-value break-word">{{proposalDetailsData.correspondenceAddress.emailId.value ? proposalDetailsData.correspondenceAddress.emailId.value : '-'}}</div>
                        </div>
                        <div class="col-6 col-md-3 col-sm-6 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Mobile Number</div>
                            <div class="row inner-label-value">{{proposalDetailsData.correspondenceAddress.mobileNumber.value ? proposalDetailsData.correspondenceAddress.mobileNumber.value : '-'}}</div>
                        </div>
                    </div>
                    <!-- <div class="row pt-4 pb-3 ml-md-4 ml-2 mr-0">
                        <div class="col-12 col-md-3 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Nominee Name</div>
                            <div class="row inner-label-value">Anupama</div>
                        </div>
                        <div class="col-12 col-md-3 pb-3 pb-md-0 col-lg-2">
                            <div class="row label-name">Nominee Relationship</div>
                            <div class="row inner-label-value">Text</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name">Aadhar Card</div>
                            <div class="row inner-label-value">6140 4981 2385</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div class="row label-name ">PAN Number</div>
                            <div class="row inner-label-value">AJXPD235D</div>
                        </div>
                    </div> -->
                </div>
                <!-- review application section ends -->
            </div>
        </div>
    </div>
</template>
<script>
import functions from '@/../../masters/functions';
import { reactive, computed, onMounted} from '@vue/composition-api';
export default {
  name: "ApplicationOverview",
  props: ['completedb','generateQuoteData','proposalDetailsData','scpaDetails'],
  components: {
  },
  setup(props , context){
    let state = reactive({
        quoteObj: {
            makeModelName: '',
            productName: '',
            title: '',
            planName: '',
            planTenure: '',
            gender: '',
            gstn: '',
            aadharCard: ''
        },
    });
    onMounted(()=>{
      setQuoteSummary();
    });
    //computed
    const checkMotorParent = computed(()=>{
      let obj = context.root.$store.getters.getMotorParentType;
      if(obj.standaloneCPA){
        return false;
      }
      return true;
    });
    //methods
    const dateObjFormated = functions.dateObjFormated;
    function setQuoteSummary(){
        // state.quoteObj.quoteId = props.completedb.quoteId;
        for(let i=0; i<props.completedb.generateQuote.riskDetails.vehicleMakeModelList.length; i++){
            if(props.generateQuoteData.riskDetails.make_model.value == props.completedb.generateQuote.riskDetails.vehicleMakeModelList[i].makeModelCode){
                state.quoteObj.makeModelName = props.completedb.generateQuote.riskDetails.vehicleMakeModelList[i].makeModelName
            }
        }
        for(let i=0; i<props.completedb.generateQuote.policyDetails.products.length; i++){
            if(props.generateQuoteData.policyDetails.productCode.value == props.completedb.generateQuote.policyDetails.products[i].code){
                state.quoteObj.productName = props.completedb.generateQuote.policyDetails.products[i].name
            }
        }
        for(let i=0; i<props.completedb.generateQuote.policyDetails.planArray.length; i++){
            if(props.generateQuoteData.policyDetails.planCode.value == props.completedb.generateQuote.policyDetails.planArray[i].planCode){
                state.quoteObj.planName = props.completedb.generateQuote.policyDetails.planArray[i].planName
            }
        }
        for(let i=0; i<props.completedb.proposalDetails.customerDetails.titleArray.length; i++){
            if(props.proposalDetailsData.customerDetails.title.value == props.completedb.proposalDetails.customerDetails.titleArray[i].code){
                state.quoteObj.title = props.completedb.proposalDetails.customerDetails.titleArray[i].name
            }
        }
        state.quoteObj.planTenure = props.generateQuoteData.policyDetails.planTenure.value.split('X')[1] == "0"? props.generateQuoteData.policyDetails.planTenure.value.split('X')[0]: props.generateQuoteData.policyDetails.planTenure.value.split('X')[1];
        // state.quoteObj.totalPremium = props.generateQuoteData.selectedPlan.totalPremium;
        // if(props.generateQuoteData.businessType == "NEW"){
        //     state.quoteObj.regNo = "NEW"
        // }
        // else{
        //     state.quoteObj.regNo = props.generateQuoteData.riskDetails.registrationNumber.value;
        // }
        // state.quoteObj.title = props.proposalDetailsData.customerDetails.title.value;
        // state.quoteObj.firstName = props.proposalDetailsData.customerDetails.firstName.value;
        // state.quoteObj.middleName = props.proposalDetailsData.customerDetails.middleName.value;
        // state.quoteObj.lastName = props.proposalDetailsData.customerDetails.lastName.value;
        // state.quoteObj.address = props.proposalDetailsData.correspondenceAddress.address.value;
        // state.quoteObj.emailId = props.proposalDetailsData.correspondenceAddress.emailId.value;
        // state.quoteObj.mobileNumber = props.proposalDetailsData.correspondenceAddress.mobileNumber.value;
        // state.quoteObj.engineNumber = props.proposalDetailsData.vehicleDetails.engineNumber.value;
        // state.quoteObj.chassisNumber = props.generateQuoteData.riskDetails.chassisNumber.value;
        // state.quoteObj.nomineeName = props.proposalDetailsData.personalAccidentCoverDetails.nomineeName.value;
        // state.quoteObj.nomineeRelation = props.proposalDetailsData.personalAccidentCoverDetails.nomineeRelation.value;
        // state.quoteObj.panNumber = props.proposalDetailsData.correspondenceAddress.panNumber.value;
    }
    //return
    return{
      state,
      checkMotorParent,
      setQuoteSummary,
      dateObjFormated
    }
  }
};
</script>

<style scoped>
/* app-overview css */
.break-word{
    word-break: break-all;
    display: block;
    width: 170px;
}
.app-overview-wrapper {
    background-color: #ffffff;
    width: calc(100% + 40px);
    max-width: 1366px;
    margin: 30px -34px 0 -32px;
    box-shadow: -10px 0 16px 5px rgba(128, 152, 213, 0.08);
    /* border: solid 1px #e8ebf2; */
}
.app-overview-row {
    padding-left: 32px;
    padding-top: 20px;
    padding-bottom: 10px;
}
.preview-btn-wrapper {
    position: absolute;
    top: 48px;
    left: 87%;
    min-width: 150px;
}
.preview {
    background-color: transparent;
    color: #0070be;
    border: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    margin-top: 16px;
}
.app-overview-outer-div {
    background-color:#f2f2f2;
}
.app-overview-inner-div {
    background-color: #ffffff;
    margin: 10px;
}
.label-name {
    color: #666666;
    font-size: 13px;
}
.label-value {
    color: #ff9b41;
    font-weight: bold;
    font-size: 15px;
}
.inner-label-value {
    color: #333333  ;
    font-weight: bold;
    font-size: 16px;
    word-break: break-word;
}
.table-striped>tbody>tr:nth-child(2n)>td,
.table-striped>tbody>tr:nth-child(2n)>th {
    background-color: #f2f2f2; 
}
.table-striped>tbody>tr:nth-child(2n+1)>td,
.table-striped>tbody>tr:nth-child(2n+1)>th {
    background-color: #fff;
}
.table-striped>thead th:first-child {
    width: 40%;
}
.loader-small img {
    width: 25px;
    height: 25px;
    margin-top: 0px;
    margin-right: 0;
}
.table > thead th{
    font-size: 16px;
}
.loader.inline img {
    margin-top: 2px ;
    margin-right: 0px;
    margin-left: 7px;
}
@media(max-width: 991px){
  .review-application{
      left: 70%;
      top: 70%;
  }
  .padding-top-nominee-details{
      padding-top: 20px;
  }
}
@media (max-width: 767px){
  .app-overview-inner-div .label-name , .inner-label-value{
     font-size:14px ;
  }
  .table > thead th {
     font-size: 14px;
  }
  .padding-top-address-details{
      padding-top: 20px;
  }
  #details_payment .table > thead th {
     padding-left: 0px;
  }
  #details_payment .table > tbody td {
     padding-left: 0px;
     padding-left: 8px ;
  }
  .review-application{
      top: 75%;
  }
}
@media (max-width: 511px){
  .label-name{
     font-size:12px ;
  }
  .label-value{
     font-size: 14px ;
  }
  .review-application{
     left: 50%;
  }
} 
@media(max-width: 1159px) and (min-width: 992px) {
  .quote-summary{
     max-width: 14%;
  }
}
@media(max-width: 991px) and (min-width: 768px) {
  .padding-top-medium-screen{
      padding-top: 20px;
  }
}
@media(max-width: 1139px) and (min-width: 992px) {
  .total-premiun-row{
     margin-left: 12px;
  }
  .plan-tenure-row{
     margin-left: 0px;
  }
}
@media(max-width: 1112px) and (min-width: 992px) {
  .total-premiun-row{
     margin-left: 0px;
  }
  .plan-name-row{
     margin-left: 15px;
  }
  .product-name-row{
     margin-left: 20px;
  }
  .make-n-model-row{
      margin-left: 8px;
  }
  .quotation-number-row{
      margin-left: 0px;
  }
}
@media(min-width : 1160px){
  .quotation-number-row{
    position: relative;
    right: 38%;
  }
  .make-n-model-row{
    position: relative;
    right: 40%;  
  }
  .product-name-row{
    position: relative;
    right: 60%;  
  }
  .plan-name-row{
    position: relative;
    right: 22%;  
  }
}
</style>
